import React, { useContext } from "react";
import { techStack } from "../constants";
import { ThemeContext } from "../themeProvider";
import { motion } from "framer-motion";


const About = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div id="about" className={darkMode === true ? "bg-white" : "bg-gray-900"}>
      <div className="max-w-7xl mx-auto x-4 sm:px-6 lg:px-8 px-4 md:mt-0 pt-24 pb-12">
        <h2
          className={
            darkMode
              ? "text-5xl font-bold px-4 md:px-0 text-center"
              : "text-5xl font-bold px-4 md:px-0 text-center text-white"
          }
        >
          About Me
        </h2>
        <div>
          <motion.div>
            <h4 className="mt-12 text-3xl font-semibold text-blue-500">
              A bit about me
            </h4>
            <p
              className={
                darkMode
                  ? "mt-4 text-xl text-justify text-gray-500"
                  : "mt-4 text-xl text-justify text-white"
              }
              style={{ letterSpacing: "-0.5px" }}
            >
              Hi there 👋, Welcome to my profile. I am a final-year student pursuing BTech in Electrical and Computer Engineering at JMI University.<br />
              <br />
              💼 Currently, I am working as a Web Developer Intern at Abhyaz, leading the Abhyaz website chatbot team. Additionally, I have worked as an Open Source Developer at SCoRe Lab, where I contributed to the project "Community Dictionary."<br />
              <br />
              👨‍💻 Over the past two years, I have built many projects, including both personal and college projects. For example, "Crypto-Trapper" will excite you if you have an interest in cryptocurrency. The "Ebooking" app is a fully-fledged application for online hotel booking, and the "Anveshan" application can provide you with transaction count, last balance change, and the validity of an address using the public address of cryptocurrency.<br />
              <br />
              💻 Skills: Programming, Software Development, Full Stack Development, Coding, Web Development, Problem solving, Data Structure, Algorithms.<br />
              <br />
              ✨ Outside of work, I play chess for stress out, read non-fiction books, and have an interest in cricket.<br />
            </p>
          </motion.div>
          <motion.div
          >
            <h4 className="mt-12 text-3xl font-semibold text-blue-500">
              Technologies and Tools
            </h4>
            <p
              className={
                darkMode
                  ? "mt-4 text-xl text-justify text-gray-500"
                  : "mt-4 text-xl text-justify text-white"
              }
            >
              Using a combination of cutting-edge technologies and reliable open-source software I build user-focused web applications.
            </p>
          </motion.div>
          <motion.div className="flex flex-wrap mt-8 flex flex-wrap justify-between ">
            {techStack.map((el, index) => (
              <motion.div
                initial="hidden"
                whileInView={"visible"}
                variants={{
                  visible: {
                    y: 0,
                    opacity: 1,
                    transition: {
                      type: "spring",
                    },
                  },
                  hidden: { opacity: 1, y: 80 },
                }}
                className="py-2 px-4 bg-gray-50 md:m-4 mx-2 mt-6 rounded-lg flex items-center hover:scale-125 cursor-pointer md:w-48 w-40"
              >
                <img alt="" src={el.link} className="w-12" />
                <h4 className="text-md ml-4">{el.name}</h4>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default About;
